// extracted by mini-css-extract-plugin
module.exports = {"closeAlertButton":"EGiftCard_closeAlertButton__1VOwy","imageUploader":"EGiftCard_imageUploader__3ichb"};